import { render, staticRenderFns } from "./LinkPatientsModal.vue?vue&type=template&id=e6121b68&"
import script from "./LinkPatientsModal.vue?vue&type=script&lang=js&"
export * from "./LinkPatientsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports